/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListVendorsQueryResponse, ListVendorsPathParams, ListVendorsQueryParams, ListVendors400, ListVendors401, ListVendors403, ListVendors404, ListVendors409, ListVendors500 } from "../../types/financialHubController/ListVendors.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListVendorsUrl(organizationId: ListVendorsPathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/financial/vendors/` as const }
  return res
}

/**
 * @summary List vendors (full register; search = typeahead capped at 25)
 * {@link /api/organizations/:organizationId/financial/vendors/}
 */
export async function listVendors(organizationId: ListVendorsPathParams["organizationId"], params?: ListVendorsQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListVendorsQueryResponse, ResponseErrorConfig<ListVendors400 | ListVendors401 | ListVendors403 | ListVendors404 | ListVendors409 | ListVendors500>, unknown>({ method : "GET", url : getListVendorsUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}